/* eslint-disable no-unused-vars */
import { styled } from "@mui/material/styles"

export const StyledContactItem = styled("div", {
  shouldForwardProp: (prop) => prop !== "selected",
})(({ theme, selected }) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  padding: "16px 24px",
  width: "100%",
  justifyContent: "space-between",
  gap: "16px",
  cursor: "pointer",
  overflow: "hidden",
  transition: "background-color 0.3s ease",

  "&::before": {
    content: '""',
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "200%",
    height: "200%",
    background: theme.palette.backgroundl300,
    transform: selected ? "translate(-50%, -50%) scale(1)" : "translate(-50%, -50%) scale(0)",
    transition: "transform 0.25s ease-out",
    borderRadius: "50%",
    zIndex: 0,
  },

  "& > *": {
    position: "relative",
    zIndex: 1,
  },
}))

export const ContactInfoWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: 6,
  flex: 1,
  minWidth: 0,
  overflow: "hidden",
}))

export const ContactTextWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minWidth: 0,
  overflow: "hidden",
}))

export const ContactName = styled("label")(({ theme }) => ({
  color: theme.palette.neutral400,
  fontWeight: 500,
  marginLeft: 8,
  fontSize: 14,
  lineHeight: "125%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: "100%",
  display: "block",
}))

export const ContactPhone = styled("label")(({ theme }) => ({
  color: theme.palette.neutral400,
  fontWeight: 400,
  marginLeft: 8,
  fontSize: 12,
  lineHeight: "125%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: "100%",
  display: "block",
}))

/** Mesmo padrão de `.responsavel` em TicketListItemCustom (ex.: ADM - Conversando) */
export const ContactConnection = styled("span")(({ theme }) => ({
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "15px",
  letterSpacing: "-0.25%",
  height: "15px",
  display: "flex",
  alignItems: "center",
  marginTop: "2px",
  marginLeft: 8,
  gap: "4px",
  color: theme.palette.neutral400,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  maxWidth: "100%",
}))
